import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../html/element'
import { Panel } from '../../../panel'
import { resetBusinessAge } from '../../store/sliceBusinessAge'
import { resetBusinessSize } from '../../store/sliceBusinessSize'
import { resetIndustry } from '../../store/sliceIndustry'
import { resetPortfolio } from '../../store/slicePortfolio'
import { resetStoreProvince } from '../../store/sliceProvince'
import { resetStoreScoreLevel } from '../../store/sliceScoreLevel'
import { SideBar } from '../components/sideBar'
import { DATA_LIST_DETAIL, TYPE_TAB_SETTING } from '../constant'

export const Detail = () => {
  const dispatch = useDispatch()

  const [onTab, changeTab] = useState(DATA_LIST_DETAIL[0].key)

  const handleReset = () => {
    switch (onTab) {
      case TYPE_TAB_SETTING.PORTFOLIO:
        dispatch(resetPortfolio())
        break
      case TYPE_TAB_SETTING.SCORE_LEVEL:
        dispatch(resetStoreScoreLevel())
        break
      case TYPE_TAB_SETTING.PROVINCE:
        dispatch(resetStoreProvince())
        break
      case TYPE_TAB_SETTING.INDUSTRY:
        dispatch(resetIndustry())
        break
      case TYPE_TAB_SETTING.BUSINESS_SIZE:
        dispatch(resetBusinessSize())
        break
      case TYPE_TAB_SETTING.YEARS_OF_OPERATION:
        dispatch(resetBusinessAge())
        break
      default:
        return null
    }
  }

  return (
    <Panel
      isI18n
      label="library.filterSetting.DETAIL"
      renderLabel={() => (
        <Element className="fstItalic" style={{ fontSize: 14 }}>
          &nbsp;
          <Translate value="library.filterSetting.TEXT_DETAIL" />
        </Element>
      )}
      height={'calc(100% - 6px)'}
    >
      <SideBar
        data={DATA_LIST_DETAIL}
        actionReset={handleReset}
        onTab={onTab}
        changeTab={changeTab}
      />
    </Panel>
  )
}
